let SetupRejectionReport = function (config) {

    let selected = [];
    let except = [];
    let statuses = {};

    let pjax = $(config.pjax);
    pjax.on('pjax:success', initEvents);

    initEvents();

    function initEvents() {
        let gridId = config.grid;
        let $grid = $(gridId);
        let checkAll = gridId + " input[name='selection_all']";
        let inputs = "input[name='selection[]']";
        let inputsEnabled = gridId + " " + inputs + ":enabled";

        $(document).off('click.yiiGridView', checkAll).on('click.yiiGridView', checkAll, function () {
            if (this.checked) {
                selectAll();
            } else {
                deselectAll();
            }

            $grid.find(inputs + ":enabled").prop('checked', this.checked);
        });

        $(document).off('click.yiiGridView', inputsEnabled).on('click.yiiGridView', inputsEnabled, function (event) {
            if (event.target.checked) {
                select($(event.target).val());
            } else {
                deselect($(event.target).val());
            }

            let all = $grid.find(inputs).length === $grid.find(inputs + ":checked").length && except.length === 0;
            $grid.find("input[name='selection_all']").prop('checked', all);
        });

        if (selected === 'all') {
            pjax.find('[name="selection[]"]').each(function (i, e) {
                if (except.indexOf(e.value) === -1 && !e.checked) {
                    e.click();
                }
            });
        }

        pjax.find('[name="status"]').change(function (event) {
            setStatus($(event.target).closest('tr').find('[name="selection[]"]').val(), $(event.target).val());
        });

        pjax.find('[data-archive-selected]').click(archiveAll);
        pjax.find('[data-handle-action]').click(archiveSingle());
    }

    function archiveSingle() {
        return function () {
            return $.post(config.postUrl, {
                selected: [$(this).data('value')],
            }, function (response) {
                if (response.success) {
                    ems.ui.notify('Payment export request successfully archived.', 'success');
                    $(config.grid).yiiGridView('applyFilter');
                } else {
                    ems.ui.notify('Something went wrong, payment export request can\'t be archived.', 'error');
                }
            });
        }
    }

    function archiveAll() {
        let data = getData();

        return $.post(config.postUrl, {
            selected: data.selected,
            except: data.except,
            filters: config.filters
        }, function (response) {
            if (response.success) {
                ems.ui.notify('Payment export request(s) successfully archived.', 'success');
                $(config.grid).yiiGridView('applyFilter');
            }
        });
    }

    function selectAll() {
        selected = 'all';
        except = [];
    }

    function deselectAll() {
        selected = [];
        except = [];
        statuses = {};
    }

    function select(id) {
        if (selected === 'all') {
            let index = except.indexOf(id);
            if (index !== -1) {
                except.splice(index, 1);
            }
            return;
        }
        selected.push(id);
    }

    function deselect(id) {
        if (selected === 'all') {
            except.push(id);
            return;
        }

        let index = selected.indexOf(id);
        if (index !== -1) {
            selected.splice(index, 1);
        }
    }

    function setStatus(id, status) {
        statuses[id] = status;
    }

    function getData() {
        let resultStatuses = {};
        for (let itemId in statuses) {
            if ((selected === 'all' || selected.indexOf(itemId) !== -1) && except.indexOf(itemId) === -1) {
                resultStatuses[itemId] = statuses[itemId];
            }
        }

        return {
            selected: selected,
            except: except,
            statuses: resultStatuses
        };
    }
};